import React, { Component } from 'react'
import { Card, CardText, Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter  } from 'reactstrap';
import axios from "axios";
import { AiOutlineUserAdd } from 'react-icons/ai';
import Loading from './Loading';

export default class SideNav extends Component {
    state = {
        groups: [],
        loading: true,
    }
    componentDidMount() {
        const auth = {
            user_id: localStorage.getItem("token")
        };
        if (localStorage.getItem("token") !== null) {
            axios.post("https://azure.ratemycourse.review/groups/", auth)
                .then(res => {
                    this.setState({ groups: res.data, loading: false });
                    console.log(res.data);
                })
        }

    }
    addCollaborator = async(grpid) =>{
        let person = prompt("Please enter your friend's email")
        if (person == null || person == "") {
            console.log("User cancelled the prompt.");
          } else {
            console.log(person+"@"+grpid);
            let colBody = {
                token: localStorage.getItem("token"),
                group_id: grpid,
                target_user_email: person
              }
            let result = await axios.post("https://azure.ratemycourse.review/share/", colBody)
            console.log(result);
          }
    }
    render() {
        return (
            <Row className="ml-5 position-fixed">
                {this.state.loading ? <Loading /> :
                    <Card body style={{ width: "210px" }}>
                        {this.state.groups.map((group, i) => (
                            <CardText style={{ color: "#6056A0", cursor: "pointer" }} key={i}>
                                <Row>
                                    <Col md="9">
                                        <a href={"/group/" + group._id} style={{ color: "#6056A0" }}>
                                            {group.group_name}
                                            {group.owner !== localStorage.getItem("token") &&
                                            <span style={{ marginLeft:"7px", marginTop:"0px", color:"white", paddingLeft:"4px",paddingRight:"4px", paddingTop:"2px",paddingBottom:"2px",  fontSize:"9px", border:"1px solid purple", backgroundColor:"#6056A0", borderRadius:"15px"}}>shared</span>
                                        }
                                        </a>
                                        
                                    </Col>
                                    
                                    <Col md="3">
                                    {group.owner === localStorage.getItem("token") && <AiOutlineUserAdd style={{ position: "floatRight" }} size={20} onClick={() => this.addCollaborator(group._id)}/>}
                                    </Col>
                                </Row>
                            </CardText>
                        ))}
                    </Card>
                }
            </Row>
        )
    }
}
